import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "src/styles";
import styled from "styled-components";

export const Icon = styled(FontAwesomeIcon)`
  color: ${colors.grey.dark};
  cursor: pointer;
  font-size: 18px;
`;

export const ModalHeader = styled.div`
  color: ${colors.grey.dark};
  border-radius: 5px 5px 0 0;
  font-size: 14px;
  font-weight: bold;

  p {
    margin: 0;
  }

  div {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  padding: 15px;
  background-color: ${colors.grey.light1};
`;
export const ModalWrapper = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const ModalWindow = styled.div`
  background-color: ${colors.white.default};
  z-index: 100;
  max-width: 600px;
  width: 100%;
  margin: 0 20px;
  border-radius: 5px;
`;

export const ModalContent = styled.div`
  padding: 0px 15px 10px 15px;

  p {
    margin: 0;
  }
`;

export const StyledModalContent = styled(ModalContent)`
  padding: 0;
`;

export const SelectionSummary = styled.div`
  background: linear-gradient(135deg, ${colors.kleenway.green}10 0%, ${colors.kleenway.green}05 100%);
  padding: 14px 24px;
  border-bottom: 1px solid ${colors.grey.light1};
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const SummaryText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${colors.grey.dark};
  font-weight: 500;
`;

export const ContentArea = styled.div`
  padding: 20px 24px;
  max-height: 55vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.grey.light1};
    border-radius: 4px;
  }
`;

export const LocationCard = styled.div<{ $hasSelection: boolean }>`
  background: ${(props: { $hasSelection: boolean }) =>
    props.$hasSelection ? `${colors.kleenway.green}05` : colors.white.default};
  border: 2px solid
    ${(props: { $hasSelection: boolean }) => (props.$hasSelection ? colors.kleenway.green : colors.grey.light1)};
  border-radius: 8px;
  // padding: 18px;
  padding: 12px;
  margin-bottom: 16px;
  transition: all 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

export const LocationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 16px;
  // padding-bottom: 14px;
  // border-bottom: 1px solid ${colors.grey.light1};
`;

export const LocationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const LocationIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  background: ${colors.kleenway.green};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white.default};
  font-size: 14px;
`;

export const LocationTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${colors.grey.dark};
`;

export const WashroomCount = styled.span`
  font-size: 12px;
  color: ${colors.grey.default};
  background: ${colors.grey.light1};
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 500;
`;

export const LocationCheckboxWrapper = styled.div`
  margin-left: auto;
`;

// const WashroomGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
//   gap: 10px;
// `;

// const WashroomCard = styled.div<{ $isSelected: boolean }>`
//   background: ${(props) => (props.$isSelected ? colors.white.default : colors.grey.light1)}20;
//   border: 1px solid ${(props) => (props.$isSelected ? colors.kleenway.green : colors.grey.light1)};
//   border-radius: 6px;
//   padding: 10px 12px;
//   transition: all 0.15s ease;

//   &:hover {
//     background: ${colors.white.default};
//     border-color: ${colors.kleenway.green};
//     transform: translateY(-1px);
//   }
// `;

export const ErrorBanner = styled.div`
  background: #fee;
  color: #c33;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 13px;
  margin-top: 16px;
  border-left: 3px solid #c33;
`;

export const ActionFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px;
  border-top: 2px solid ${colors.grey.light1};
  background: ${colors.grey.light1}30;
`;

export const BaseBtn = styled.button`
  padding: 11px 28px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:not(:disabled):active {
    transform: translateY(0);
  }
`;

export const CancelBtn = styled(BaseBtn)`
  background: ${colors.white.default};
  color: ${colors.grey.dark};
  border: 2px solid ${colors.grey.light1};

  &:hover {
    background: ${colors.grey.light1};
  }
`;

export const GenerateBtn = styled(BaseBtn)`
  background: ${colors.kleenway.green};
  color: ${colors.white.default};
  box-shadow: 0 2px 8px ${colors.kleenway.green}40;

  &:hover {
    background: ${colors.kleenway.green};
    opacity: 0.9;
  }
`;
